import { Icon, Stack } from '@asgard/ui-library';
import { faLinkedin, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { faXTwitter } from 'components/shared/XTwitterIcon';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Element, Link as LinkScroll } from 'react-scroll';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { LOGO_MANFRED } from 'utils/logos';
import { getPublicPath } from 'utils/paths';
import * as S from './Fredcon25.styled';
import React from 'react';

export const Fredcon25: React.FC = () => {
  const { t } = useI18n('fredcon25');
  const { locale } = useRouter();

  const GetTicketButton = (
    <S.GetTicketButton
      href={`https://getmanfred.typeform.com/fredcon`}
      target="_blank"
    >
      {t('fredcon.get-ticket')}
      <Icon icon={faArrowRight} />
    </S.GetTicketButton>
  );

  const agenda = [
    { break: false },
    { break: false },
    { break: false },
    { break: false },
    { break: false },
    { break: true },
    { break: false },
    { break: false },
    { break: false },
    { break: false },
    { break: true },
    { break: false },
    { break: false },
    { break: false },
    { break: false },
    { break: false },
    { break: true }
  ];

  return (
    <S.Root>
      <S.Fredon25GlobalStyles />
      <S.Header>
        <S.HeaderNav>
          <S.HeaderContainer>
            <Stack
              alignment="center"
              contentAlign="space-between"
              className="header"
            >
              <Stack alignment="center" gap="5xl">
                <Link href={getAppUrl(APP_URLS.home, locale)} passHref>
                  <S.HeaderNavLogo>
                    <img
                      src={LOGO_MANFRED}
                      alt="Manfred logo"
                      className="brand"
                    />
                  </S.HeaderNavLogo>
                </Link>

                <Stack className="nav">
                  <LinkScroll href="#agenda" to="agenda">
                    {t('fredcon.header.nav-1')}
                  </LinkScroll>
                  <LinkScroll href="#donde" to="donde">
                    {t('fredcon.header.nav-2')}
                  </LinkScroll>
                  <LinkScroll href="#speakers" to="speakers">
                    {t('fredcon.header.nav-3')}
                  </LinkScroll>
                  <LinkScroll href="#entradas" to="entradas">
                    {t('fredcon.header.nav-4')}
                  </LinkScroll>
                  <LinkScroll href="#contacto" to="contacto">
                    {t('fredcon.header.nav-5')}
                  </LinkScroll>
                </Stack>
              </Stack>

              {GetTicketButton}
            </Stack>
          </S.HeaderContainer>
        </S.HeaderNav>
        <S.HeaderNotice>
          <S.HeaderContainer>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.header.notice" />
          </S.HeaderContainer>
        </S.HeaderNotice>
      </S.Header>

      <S.Container>
        <S.Hero>
          <S.HeroTitle>
            <span>{t('fredcon.hero.title-pre')}</span>
            <img
              src={getPublicPath(`/images/fredcon25/title.png`)}
              alt={t(`fredcon.hero.title`)}
              className="title-img"
            />
            <img
              src={getPublicPath(`/images/fredcon25/logo.png`)}
              alt={t(`fredcon.hero.logo`)}
              className="logo-img"
            />
          </S.HeroTitle>

          <S.HeroDesc>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.hero.desc" />
          </S.HeroDesc>

          <S.HeroDate>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.hero.date" />
          </S.HeroDate>
        </S.Hero>

        <Stack wrap>
          {Array.from({ length: 10 }).map((_, index) => (
            <S.HeroHost key={index}>
              <img
                src={getPublicPath(`/images/fredcon25/host-${index + 1}.png`)}
                alt={t(`fredcon.hero.hosts.host-${index + 1}.name`)}
              />
              <div>
                <strong>
                  {t(`fredcon.hero.hosts.host-${index + 1}.name`)}
                </strong>
                <span>{t(`fredcon.hero.hosts.host-${index + 1}.desc`)}</span>
              </div>
            </S.HeroHost>
          ))}
        </Stack>

        <S.What>
          <h2>{t('fredcon.what.title')}</h2>

          <S.WhatDesc>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.what.desc" />
          </S.WhatDesc>
        </S.What>

        <S.Where>
          <Element name="donde" id="donde"></Element>
          <h2>{t('fredcon.where.title')}</h2>

          <S.WhereWrapper>
            <S.WhereDesc>
              <HtmlTrans ns="fredcon25" i18nKey="fredcon.where.desc" />
            </S.WhereDesc>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.9897840543754!2d-3.7068436000000005!3d40.4090771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4227fc14e5d533%3A0xd840f5b434384bc7!2sEspacio%20Rastro%20Madrid!5e0!3m2!1sen!2ses!4v1747216832762!5m2!1sen!2ses"
              style={{ border: 0 }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </S.WhereWrapper>
        </S.Where>

        <S.Agenda>
          <Element name="agenda" id="agenda"></Element>
          <h2>{t('fredcon.agenda.title')}</h2>

          <Stack direction="column">
            {agenda.map((item, index) => (
              <S.AgendaItem key={index} isBreak={item.break}>
                <S.AgendaItemTime>
                  {t(`fredcon.agenda.agenda-${index + 1}.time`)}
                </S.AgendaItemTime>

                <S.AgendaItemContent>
                  <HtmlTrans
                    ns="fredcon25"
                    i18nKey={`fredcon.agenda.agenda-${index + 1}.content`}
                  />
                </S.AgendaItemContent>
              </S.AgendaItem>
            ))}
          </Stack>
        </S.Agenda>

        <S.Speakers>
          <Element name="speakers" id="speakers"></Element>
          <h2>{t('fredcon.speakers.title')}</h2>

          <S.SpeakersDesc>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.speakers.desc" />
          </S.SpeakersDesc>

          <Stack wrap gap="l">
            {Array.from({ length: 11 }).map((_, index) => (
              <S.Speaker key={index}>
                <div>
                  <img
                    src={getPublicPath(
                      `/images/fredcon25/speaker-${index + 1}.png`
                    )}
                    alt={t(`fredcon.speakers.speaker-${index + 1}.name`)}
                  />

                  <span>
                    <strong>
                      {t(`fredcon.speakers.speaker-${index + 1}.name`)}
                    </strong>
                    <span>
                      {t(`fredcon.speakers.speaker-${index + 1}.desc`)}
                    </span>
                  </span>
                </div>
                <a
                  href={t(`fredcon.speakers.speaker-${index + 1}.linkedin`)}
                  target="_blank"
                >
                  <Icon icon={faLinkedin} size="xl" />
                </a>
              </S.Speaker>
            ))}
          </Stack>
        </S.Speakers>

        <S.Tickets>
          <Element name="entradas" id="entradas"></Element>
          <h2>{t('fredcon.tickets.title')}</h2>

          <S.TicketsWrapper>
            <span>{t('fredcon.hero.title-pre')}</span> {t('fredcon.hero.title')}
            <S.TicketsDesc>
              <HtmlTrans ns="fredcon25" i18nKey="fredcon.tickets.desc" />
            </S.TicketsDesc>
            <div>{GetTicketButton}</div>
          </S.TicketsWrapper>
        </S.Tickets>

        <S.Partners>
          <Element name="partners" id="partners"></Element>
          <h2>{t('fredcon.partners.title')}</h2>

          <Stack direction="column" gap="l">
            {[3, 3, 4]
              .reduce(
                (acc, size, rowIndex) => {
                  const rowItems = acc.remaining.slice(0, size);
                  acc.remaining = acc.remaining.slice(size);
                  acc.rows.push(rowItems);
                  return acc;
                },
                {
                  rows: [] as number[][],
                  remaining: Array.from({ length: 10 }, (_, i) => i + 1)
                }
              )
              .rows.map((row, rowIndex) => (
                <Stack key={rowIndex} wrap gap="l" alignment="center">
                  {row.map((partnerIndex) => (
                    <S.Partner
                      key={partnerIndex}
                      href={t(`fredcon.partners.partner-${partnerIndex}.url`)}
                      target="_blank"
                    >
                      <img
                        src={getPublicPath(
                          `/images/fredcon25/partner-${partnerIndex}.svg`
                        )}
                        alt={t(`fredcon.partners.partner-${partnerIndex}.name`)}
                      />
                    </S.Partner>
                  ))}
                </Stack>
              ))}
          </Stack>
        </S.Partners>

        <S.Footer>
          <Element name="contacto" id="contacto"></Element>

          <S.FooterContact>
            <HtmlTrans ns="fredcon25" i18nKey="fredcon.footer.contact" />
          </S.FooterContact>

          <S.FooterInfo>
            <Stack contentAlign="space-between">
              <h1>
                <span>{t('fredcon.hero.title-pre')}</span>{' '}
                {t('fredcon.hero.title')}
              </h1>

              <img
                src={getPublicPath('/images/fredcon25/manfred-tecnofor.svg')}
                alt="Manfred + Tecnofor"
              />
            </Stack>

            <nav>
              <span>
                © {new Date().getFullYear()} <strong>Manfred Tech</strong> S.L.
              </span>
              <a href={getAppUrl(APP_URLS.termsOfUse)} target="_blank">
                {t('fredcon.footer.nav.terms')}
              </a>
              <a href={getAppUrl(APP_URLS.privacyPolicy)} target="_blank">
                {t('fredcon.footer.nav.privacy')}
              </a>
              <a href={getAppUrl(APP_URLS.cookies)} target="_blank">
                {t('fredcon.footer.nav.cookies')}
              </a>
              <a href="https://twitter.com/getmanfred" target="_blank">
                <Icon icon={faXTwitter} size="l" />
              </a>
              <a href="https://t.me/getmanfred" target="_blank">
                <Icon icon={faTelegram} size="l" />
              </a>
            </nav>
          </S.FooterInfo>
        </S.Footer>
      </S.Container>
    </S.Root>
  );
};
